module.exports = __webpack_public_path__ + "static/how-it-works-1-95fbf78905c0505d4f4fdccd875b16c2.png";